module.exports = __webpack_public_path__ + "img/mgs.b18baca7.jpg";